import {Button, Space} from "antd";
import React, {useRef, useState} from "react";
import {Input} from "antd/lib";
import {Search} from "lucide-react";
import DateRangeFilter from "../../common/date-range-filter/date-range-filter";
import {DateRangeType} from "../../common/date-range-filter/type/date-range-filter.type";

interface PollToolbarProps {
    onFilterChange: (type: string) => void;
    fetchPolls: (payload: any) => void;
    handleDateChange: (range: { startDate: string, endDate: string, type: DateRangeType }) => void;
}

const PollToolbar = ({onFilterChange, fetchPolls, handleDateChange}: PollToolbarProps) => {
    const [selectedTab, setSelectedTab] = useState("ACTIVE");
    const timerRef = useRef<any>(null);

    const handleTabsClick = (filter: string) => {
        setSelectedTab(filter);
        onFilterChange(filter);
    };

    function handlePollSearch(e: any) {
        const value = e.target.value;

        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }

        timerRef.current = setTimeout(() => {
            fetchPolls({
                title: value
            });
        }, 500);
    }

    return (
        <div className="poll-toolbar-container">
            <Space>
                <Input
                    className={'poll-search-bar'}
                    placeholder={"Search title..."}
                    allowClear
                    prefix={<Search className={'poll-search-icon'}/>}
                    onChange={(e) => handlePollSearch(e)}
                />

                <Button
                    type={selectedTab === "ALL" ? "primary" : "default"}
                    onClick={() => handleTabsClick("ALL")}
                >
                    All
                </Button>

                <Button
                    type={selectedTab === "POLL" ? "primary" : "default"}
                    onClick={() => handleTabsClick("POLL")}
                >
                    Poll
                </Button>

                <Button
                    type={selectedTab === "VOTE" ? "primary" : "default"}
                    onClick={() => handleTabsClick("VOTE")}
                >
                    Vote
                </Button>

                <Button
                    type={selectedTab === "ACTIVE" ? "primary" : "default"}
                    onClick={() => handleTabsClick("ACTIVE")}
                >
                    Active
                </Button>

                <Button
                    type={selectedTab === "INACTIVE" ? "primary" : "default"}
                    onClick={() => handleTabsClick("INACTIVE")}
                >
                    Inactive
                </Button>
            </Space>

            <DateRangeFilter
                onChange={handleDateChange}
            />
        </div>
    );
};

export default PollToolbar;